import { Currency, Token } from '@etcswapv2/sdk-legacy'

export function currencyId(currency: Currency): string {
  // Use 'address' property check instead of reference equality to avoid module duplication issues
  if (!('address' in currency)) return 'ETC'
  return (currency as Token).address
}
